import { preventSamePageNavigation } from "@/utils/navigation";
import { createAnimation } from "./utils";
import s from "./style.module.css";
export interface Input extends Marko.HTML.A {
    animate?: boolean;
    scrollTarget?: () => HTMLDivElement;
}
<let/animating=input.animate || false>
<let/reduceMotion=false>
<let/scale=6>
<let/offsetY=160>

<a/logoRef
    class=s.logo
    href="/"
    data-should-animate=`${input.animate ?? false}`
    data-reduce-motion=`${reduceMotion}`
    data-animating=`${animating}`
    tabindex=(animating ? -1 : 0)
    onClick(e) {
        preventSamePageNavigation(e, logoRef());
    }>
    eBay Design
</a>
<script>
    const setAnimationParams = () => {
        if (typeof window === "undefined") scale = 6;
        else {
            scale = Math.min(window.innerWidth / 200, 8.5);
            offsetY = Math.min(
                64 + window.innerWidth * 0.15,
                348 + window.innerWidth * 0.015,
            );
        }
    };
    setAnimationParams();
    window.addEventListener("resize", setAnimationParams, {
        signal: $signal,
    });
</script>
<script>
    const scrollTarget = input.scrollTarget?.();
    if (input.animate && scrollTarget) {
        const observer = new IntersectionObserver(([entry]) => {
            const { top, height } = entry.boundingClientRect;
            if (top + height < 0) animating = false;
            else animating = true;
        });
        observer.observe(scrollTarget);
        $signal.onabort = () => {
            observer.unobserve(scrollTarget);
            observer.disconnect();
        };
    }
</script>
<script>
    const scrollTarget = input.scrollTarget?.();
    const prm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    reduceMotion = prm;
    //
    if (!prm && input.animate && scrollTarget) {
        const cancelLogo = createAnimation(logoRef(), scrollTarget, {
            scale: [scale, 1],
            y: [offsetY, 0],
        });
        $signal.onabort = () => {
            cancelLogo();
        };
    }
</script>
